// -----------------------------------------------------------
// On scroll pin accordion items on screen
// Janovec - 18.10.22
// V 1.1 - alfa

import {gsap} from "gsap";
import {ScrollTrigger} from "gsap/ScrollTrigger";
import ScrollToPlugin from "gsap/ScrollToPlugin";

gsap.registerPlugin(ScrollTrigger, ScrollToPlugin)

const ScrollAccordion = {
    trigger: null,
    headerHeight:76,

    init(el) {
        this.el = el;
        this.holder = el.find('.holder');
        this.items = el.find('[container]');
        this.count = this.items.length - 1;
        this.height = this.items.length * -2;
        this.top = this.el.offset().top;
        this.bind();
    },

    bind() {

        this.items.each((i, item) => {
            this.bindItems(i, item);
        });

        gsap.set(this.el, {height: this.height});

        ScrollTrigger.create({
            id: 'triggerEl',
            trigger: this.holder,
            pin: true,
            start: "top top+=90px",
            end: "bottom bottom",
            invalidateOnRefresh: true,
            // marker: true
        });
    },

    bindItems(i, item) {
        this.height += this.headerHeight + $(item).outerHeight();
        if (i >= this.count) return;

        item.tl = gsap.timeline({
            scrollTrigger: {
                id: 'triggerItem' + i,
                scrub: true,
                start: () => this.top + (window.innerHeight * i),
                end: () => this.top + (window.innerHeight * (i + 1)),
                invalidateOnRefresh: true,
                // markers: true,
            }
        });

        item.tl.to(item, {height: this.headerHeight});
    },

    kill() {
        if (!this.el || !this.items) return;

        this.items.each((i, item) => {
            if (i >= this.count) return;
            item.tl.pause(0).kill(true);
            gsap.set(item, {clearProps: true});
        })

        ScrollTrigger.getById('triggerEl').kill(true);
    }
};

export default ScrollAccordion;
// window.ScrollAccordion = ScrollAccordion;